import React from "react";
import styles from "./styles.css";
import Salecarsafely from "../../shared/images/covid-assets/sell-car-safely.png";
import Safebranches from "../../shared/images/covid-assets/safe-branches.png";
import Safehomeinspection from "../../shared/images/covid-assets/safe-home-inspection.png";
import CustomerSafetyCard from "../customer-safe-card";

const SellCarSafely = () => {
    return (
        <React.Fragment>
            <section styleName={"styles.nearestbranchBox"}>
                <div className="container">
                    <h3>Sell your car safely with us at your home or nearest CARS24 branch</h3>
                    <div className="row">
                        <div className="col-6">
                            <img src={Salecarsafely} className="img-fluid"/>
                        </div>
                        <div className="col-6">
                            <CustomerSafetyCard
                                heading="Safe & Sanitized Branches"
                                text="Sanitization and disinfection of all CARS24 branches every
                            4 hours as recommended by WHO, regular disinfection of common touch
                            surfaces like door handles, furniture, electric switches & various
                            gadgets used for car inspection."
                                image= {Safebranches}
                            />
                            <CustomerSafetyCard
                                heading="Safe Home Inspection"
                                text="Sell your car safely from the comfort of your home to a
                                    CARS24 executive with minimum interaction and no physical
                                    contact."
                                image= {Safehomeinspection}
                            />
                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
};

export default SellCarSafely;
